export const userAdapter = (user = {}) => {
  return {
    id: user.id,
    firstName: user.name,
    lastName: user.last_name,
    email: user.email,
    expireDate: user.expire_at,
    status: user.active,
    department: user.department_id,
    company: user.company_info_id,
    language: user.language,
    ip: user.ip,
    customerLabel: user.customer_label,
  };
};
